import { isObject, isArray } from 'lodash';

export default function convertDataKeys(data = {}, converter) {
  function convert(subData) {
    function mapValue(value) {
      return value.map((v) => {
        if (isArray(v)) {
          return mapValue(v);
        } else if (isObject(v)) {
          return convert(v);
        }

        return v;
      });
    }

    return Object.keys(subData).reduce((prev, key) => {
      const modifiedPrev = { ...prev };
      const value = subData[key];
      let newValue = value;

      if (isArray(value)) {
        newValue = mapValue(value);
      } else if (isObject(value)) {
        newValue = convert(value);
      }

      modifiedPrev[converter(key)] = newValue;

      return modifiedPrev;
    }, {});
  }

  if (!converter) {
    return data;
  }

  return convert(data);
}
